<!-- Popup for global file upload (add data) -->
<div class="fdm-dialog fdm-fade" id="panel-upload-simple">
  <div class="fdm-overlay-full" (click)="dialogRef.close()"></div>
  <mat-card class="fdm-dropdown-panel">

    <!-- Add data -->
    <mat-card-header class="header">
      <div class="subheading-2 title">{{ 'MAP.ADD_DATA' | translate }}</div>
      <!-- <button mat-button class="mr-3" (click)="reset()">{{'GENERIC.RESET' | translate}}</button> -->
      <div class="header-actions">
        <fa-icon class="fdm-link" icon="times" style="font-size:22px;margin-right:5px;" (click)="dialogRef.close()"></fa-icon>
      </div>
    </mat-card-header>

    <!-- Drag/drop files -->
    <mat-card-content class="fdm-drag-drop-section p-3" style="min-height:55vh;border-bottom:solid 1px #ddd;">

      <div *ngIf="showImport" id="addDataFeed">
        <h3>
          {{ 'MAP.WMS.DATA_FEED' | translate }}
          <fa-icon class="fdm-link" icon="times" class="fdm-link float-right" style="font-size:22px;margin-right:5px;" (click)="toggleShowImport()"></fa-icon>
        </h3>

        <div class="alert alert-secondary" style="border-radius:0 !important;font-size:12px;">

          <p>{{ 'MAP.WMS.DATA_FEED_INFO' | translate }} </p>
          
          <button mat-button color="primary" [matMenuTriggerFor]="examples">{{ 'MAP.TRYOUT.EXAMPLES' | translate }} <fa-icon icon="chevron-down"></fa-icon></button>
          <mat-menu #examples="matMenu">
            <button mat-menu-item *ngFor="let i of exampleUrls" (click)="selectExample(i.url)">{{ i.label }}</button>
          </mat-menu>

        </div>

        <div class="content">
          <table *ngIf="urlRequest">
            <tr>
              <td style="vertical-align:top;width:45%;">
                {{ 'API.URL' | translate }}
                <div style="margin:15px 0 8px 0;" class="fdm-linked" (click)="toggleShowAdvanced()"> {{ 'NAV.ADVANCED' | translate }}
                  <fa-icon *ngIf="showAdvanced" icon="chevron-up"></fa-icon>
                  <fa-icon *ngIf="!showAdvanced" icon="chevron-down"></fa-icon>
                </div>
              </td>
              <td style="vertical-align:top" class="fdm-expand-on-focus-container">
                <!-- <input [(ngModel)]="urlRequest.url" name="url" /> -->
                <input id="fdm-import-url" type="text" [(ngModel)]="urlRequest.url" name="url" class="fdm-expand-on-focus"> 
              </td>
            </tr>
            <tr *ngIf="showAdvanced">
              <td style="vertical-align:top">{{ 'API.USERNAME' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td style="vertical-align:top"><input [(ngModel)]="urlRequest.username" name="username" /></td>
            </tr>
            <tr *ngIf="showAdvanced">
              <td style="vertical-align:top">{{ 'API.PASSWORD' | translate }} ({{ 'FORMS.OPTIONAL' | translate }})</td><td style="vertical-align:top"><input type="password" [(ngModel)]="urlRequest.password" name="password" /></td>
            </tr>
          </table>

          <div style="text-align:right;margin-top:20px;">
            <button style="color:#999 !important;margin-right:10px;" (click)="toggleShowImport();" mat-raised-button>
              <fa-icon icon="times"></fa-icon> {{ 'GENERIC.CANCEL' | translate }}
            </button>
            <button (click)="toggleShowImport();requestUrl();"  mat-raised-button color="primary">
              <fa-icon icon="cloud-download-alt"></fa-icon> {{ 'MAP.WMS.IMPORT' | translate }}
            </button>
          </div>
        </div>
      </div>

      <table class="fdm-tree-structure-table">
        <tr>
          <th class="folders"><b>{{ 'MAP.WMS.EXPLORE' | translate }}</b> {{ 'MAP.WMS.OR' | translate }} <button style="padding:5px 10px !important;" mat-raised-button class="ml-1" color="primary" (click)="toggleShowImport()"><fa-icon icon="link"></fa-icon> {{ 'MAP.WMS.IMPORT_URL' | translate }}</button></th>
          <th class="checkboxes">{{ 'MAP.WMS.SELECTION' | translate }}</th>
          <th style="padding-left:20px;">{{ 'MAP.WMS.INFO' | translate }}</th>
        </tr>
      </table>
      
      <div style="position:absolute;float:right;font-size:0.8rem;width:calc(100% - 473px);height:calc(100% - 206px);overflow-y:auto;overflow-x:hidden;margin-left:427px;padding-top:20px;">
        
        <div class="alert alert-secondary" style="padding:30px;" *ngIf="!currentItem">
          <p>{{ 'MAP.WMS.EXPLORE_ITEM' | translate }}</p>
          <p>{{ 'MAP.WMS.SELECT_ITEM' | translate }}</p>
        </div>

        <div *ngIf="currentItem">

          <!-- All good objects have a meta sub-object loaded with goodies ... -->
          <ng-container *ngIf="meta">

            <div id="previewMap" style="width:100%;height:200px;background-color:#ddd;margin-bottom:5px;">
              <div *ngIf="showPreviewMap" style="position: fixed;z-index: 9999;padding: 5px 10px;font-size: 11px;color: #c7c7c7;background-color: #00000044;text-transform: uppercase;">{{ 'MAP.WMS.AREA_PREVIEW' | translate }}</div>
              <div style="position:absolute;width:100%;text-align:center;margin-top:50px;">{{ 'MAP.WMS.PREVIEW' | translate }}</div>
              <map-viewer *ngIf="showPreviewMap" name="mini"></map-viewer>
            </div>

            <h4 *ngIf="meta.label">{{ meta.label }}</h4>
            <p *ngIf="meta.subLayers && meta.subLayers.length">{{ 'MAP.WMS.COLLECTION' | translate }} {{ meta.subLayers.length }} {{ 'MAP.WMS.LAYERS' | translate }}</p>
            <p *ngIf="meta.description">{{ meta.description }}</p>

          </ng-container>

          <!-- Info on non-WMS (and non-supported, or non-meta objects, like a folder but with no meta sub-object) -->
          <ng-container *ngIf="!meta">

            <!-- metadata about selected item here -->
            <h4 (click)="toggleDebug()">{{ currentItem.name }}</h4>
            <div *ngIf="currentItem?.label">
              <h4>{{ currentItem.label }} (label)</h4>
            </div>  
          </ng-container>

          <!-- debug dump for now -->
          <b class="fdm-linked" (click)="toggleDebug()">.</b>
            
          <!-- <textarea style="margin-top:40px;width:100%;height:200px;font-size:10px;">{{ currentItem | json }}</textarea> -->
          <textarea *ngIf="showDebug" style="margin-top:40px;width:100%;height:200px;font-size:10px;">{{ meta | json }}</textarea>
        </div>
      </div>

      <div class="clearfix"></div>

      <div style="max-height:50vh;overflow-y:auto;width:420px;">
        <table class="fdm-tree-structure-table" style="width:400px;">
          <tr>
            <td class="folders">
              <tree-view (change)="onChange($event)" [rootLevelStore]="itemsStore"></tree-view>
              <div *ngIf="loading" class="container">
                <div class="row w-100">
                  <div class="col-md-6 offset-md-3">
                    <mat-spinner style="margin: 0 auto;"></mat-spinner>
                  </div>
                </div>
              </div>
            </td>
            <td class="checkboxes"></td>
            <!-- <td class="preview" style="background-color:lightcyan"></td> -->
          </tr>
        </table>
      </div>

        <!-- <div class="row">
          <div class="col-sm">
            <p>{{'MAP.WMS_HINT' | translate}}</p>
            <mat-form-field class="w-400">
              <mat-label>{{'MAP.WMS_URL' | translate}}</mat-label>
              <input matInput placeholder="{{'MAP.WMS_URL' | translate}}" [(ngModel)]="urlRequest.url">
            </mat-form-field>
          
            <button mat-raised-button [disabled]="!urlRequest.url?.length" color="primary" class="mr-3" (click)="requestUrl()">{{'GENERIC.SUBMIT' | translate}}</button>
          </div>
        </div>
    
        <div class="row w-100">
          <div class="col-5" style="min-width:320px;">
            <tree-view (change)="onChange($event)" [rootLevelStore]="itemsStore"></tree-view>
          </div>
          <div class="col-7" style="border-left:dotted 1px #ccc;">
            <textarea style="width:100%;height:300px;font-size:10px;">{{ currentItem | json }}</textarea>
            !--
            <div *ngIf="currentItem?.label">
              <h4>{{currentItem.label || 'No Label'}}</h4>
              <p>Type: {{ 'TYPES.' + data.type | translate }}</p>
              <p>Location: {{ currentItem.bounds.minX }} / {{ currentItem.bounds.minY }}</p>
              <p>{{currentItem.description || data.description || 'No description'}}</p>
            </div>
            <div *ngIf="currentItem?.name">
              <h4>Bulk Brett Loaded Excel {{ currentItem.name }}</h4>
              <p>Type: {{ 'TYPES.' + currentItem.transforms[0] | translate }}</p>
              <p>Location: {{ currentItem.llng }} / {{ currentItem.llat }}</p>
              <p>TODO suck the descriptions for these items too</p>
            </div>
            -
          </div>
        </div> -->

    </mat-card-content>

    <mat-card-actions class="text-right m-0 p-4">
      <button mat-raised-button type="button" (click)="dialogRef.close()">{{ 'GENERIC.CANCEL' | translate }}</button>
      <!-- <button mat-raised-button color="primary" type="button" (click)="add()" class="ml-2">Add</button> -->
      <button mat-raised-button class="ml-2" color="accent" (click)="download()" *ngIf="selectedItems.size">{{'GENERIC.IMPORT_I' | translate:{count:selectedItems.size,s:selectedItems.size > 1?'s':''}  }} </button>
      
  </mat-card-actions>

  </mat-card>
</div>
